var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ImageParser mx-auto"},[_c('img',{staticClass:"img-fluid animate__animated animate__fadeIn",attrs:{"src":_vm.content}})])}
var staticRenderFns = []

export { render, staticRenderFns }